import { render, staticRenderFns } from "./MyPlanUpload.vue?vue&type=template&id=679a1ce8&scoped=true&"
import script from "./MyPlanUpload.vue?vue&type=script&lang=ts&"
export * from "./MyPlanUpload.vue?vue&type=script&lang=ts&"
import style0 from "./MyPlanUpload.vue?vue&type=style&index=0&id=679a1ce8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a1ce8",
  null
  
)

export default component.exports